export default __webpack_public_path__ + "static/media/magento2-negative.9b40dc79.svg";